import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="shell footer">
      <span>H→ HEIC Studio</span>
      <nav aria-label="Legal">
        <Link to="/privacy/">Privacy</Link>
        <Link to="/terms/">Terms</Link>
        <Link to="/licenses/">Licenses</Link>
      </nav>
    </footer>
  )
}
